import MaterialFormControl from "../../../../__snowpack__/pkg/@mui/material/FormControl.js";
import MaterialFormGroup from "../../../../__snowpack__/pkg/@mui/material/FormGroup.js";
import MaterialFormHelperText from "../../../../__snowpack__/pkg/@mui/material/FormHelperText.js";
import MaterialFormLabel from "../../../../__snowpack__/pkg/@mui/material/FormLabel.js";
import {useFormikContext} from "../../../../__snowpack__/pkg/formik.js";
import React, {useMemo} from "react";
function FormControl({
  children,
  component = "fieldset",
  name,
  label,
  helperText,
  variant = "outlined",
  required,
  htmlFor
}) {
  const {
    getFieldMeta,
    submitCount
  } = useFormikContext();
  const meta = useMemo(() => name ? getFieldMeta(name) : void 0, [getFieldMeta, name]);
  const text = useMemo(() => meta && (meta?.touched || +submitCount > 0) && meta?.error ? meta?.error : helperText, [helperText, meta, submitCount]);
  return /* @__PURE__ */ React.createElement(MaterialFormControl, {
    component,
    required,
    variant,
    error: !!((meta?.touched || +submitCount > 0) && meta?.error)
  }, label && /* @__PURE__ */ React.createElement(MaterialFormLabel, {
    className: `MuiInputLabel-${variant}`,
    component: "legend",
    htmlFor
  }, label), /* @__PURE__ */ React.createElement(MaterialFormGroup, null, children), text && /* @__PURE__ */ React.createElement(MaterialFormHelperText, {
    variant
  }, text));
}
export default /* @__PURE__ */ React.memo(FormControl);
